import React from "react";
import PropTypes from "prop-types";
import {
  ProcessingScreenContainer,
  ProcessingIconWrapper,
  ProcessingTitle,
  ProcessingDescription,
  ProcessingButtonWrapper,
  AllSetScreenContainer,
  AllSetIconWrapper,
  AllSetTitle,
  AllSetDescription,
  AllSetButtonWrapper,
} from "./CreateSurmountAccountModal.styles";

const VARIANT_CONFIG = {
  processing: {
    Container: ProcessingScreenContainer,
    IconWrapper: ProcessingIconWrapper,
    Title: ProcessingTitle,
    Description: ProcessingDescription,
    ButtonWrapper: ProcessingButtonWrapper,
    wrapperClassName: "container-processing",
  },
  allSet: {
    Container: AllSetScreenContainer,
    IconWrapper: AllSetIconWrapper,
    Title: AllSetTitle,
    Description: AllSetDescription,
    ButtonWrapper: AllSetButtonWrapper,
    wrapperClassName: "container-all-set",
  },
};

export const StatusScreen = ({
  variant,
  icon: Icon,
  title,
  description,
  buttonLabel,
  onContinue,
  className,
  showButton = true,
}) => {
  const components = VARIANT_CONFIG[variant];

  if (!components) {
    return null;
  }

  const {
    Container,
    IconWrapper,
    Title,
    Description,
    ButtonWrapper,
    wrapperClassName,
  } = components;

  return (
    <Container className={className}>
      <div className={wrapperClassName}>
        <IconWrapper>{Icon ? <Icon /> : null}</IconWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
        {showButton ? (
          <ButtonWrapper>
            <button onClick={onContinue}>{buttonLabel}</button>
          </ButtonWrapper>
        ) : null}
      </div>
    </Container>
  );
};

StatusScreen.propTypes = {
  variant: PropTypes.oneOf(["processing", "allSet"]).isRequired,
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  buttonLabel: PropTypes.string,
  onContinue: PropTypes.func,
  className: PropTypes.string,
  showButton: PropTypes.bool,
};

export default StatusScreen;
